import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import logo from './assets/formicary-logo.png';

export default function HomePage() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-white text-gray-900">
      <nav className="sticky top-0 z-50 bg-white shadow-md py-4 px-8 flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <img src={logo} alt="Formicary Logo" className="h-10 w-auto" />
          <span className="text-xl font-bold">Formicary Innovation Labs</span>
        </div>
        <div className="space-x-6 hidden md:flex">
          <a href="#about" className="hover:text-blue-600">About</a>
          <a href="#services" className="hover:text-blue-600">Services</a>
          <a href="#projects" className="hover:text-blue-600">Projects</a>
          <a href="#team" className="hover:text-blue-600">Team</a>
          <a href="#contact" className="hover:text-blue-600">Contact</a>
        </div>
        <a href="#contact-form" className="ml-auto md:ml-0 bg-blue-600 text-white px-4 py-2 rounded-xl hover:bg-blue-700 transition">
          Get in Touch
        </a>
      </nav>

      <section className="h-[90vh] flex flex-col justify-center items-center text-center px-6" data-aos="fade-up">
        <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-4">
          Innovating the Future with AI, ML, and 6G
        </h1>
        <p className="text-lg md:text-xl text-gray-600 max-w-2xl mb-6">
          Empowering digital transformation with cutting-edge research and intelligent solutions.
        </p>
        <button className="text-lg px-8 py-4 bg-blue-600 text-white rounded-xl">Explore Our Services</button>
      </section>

      <section id="about" className="py-20 px-6 bg-gray-50 text-center" data-aos="fade-right">
        <h2 className="text-3xl font-semibold mb-4">About Us</h2>
        <p className="max-w-3xl mx-auto text-lg text-gray-700">
          Formicary Innovation Labs LLP is a deep-tech startup focused on AI, ML, and 6G communication systems, incubated at IIIT Guwahati. We integrate research with real-world applications to create AI-driven automation, intelligent network optimization, and advanced digital platforms.
        </p>
      </section>

      <section id="services" className="py-20 px-6 text-center" data-aos="fade-left">
        <h2 className="text-3xl font-semibold mb-4">Our Services</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
          <ServiceCard title="AI & ML Solutions" desc="Developing intelligent systems for automation, prediction, and optimization." />
          <ServiceCard title="6G Wireless R&D" desc="Building next-generation communication technologies and smart infrastructures." />
          <ServiceCard title="Custom Software Development" desc="Tailored end-to-end software solutions from design to deployment." />
          <ServiceCard title="Web & Mobile Development" desc="High-performance digital platforms built with cutting-edge technologies." />
          <ServiceCard title="Business Intelligence" desc="Strategic consulting powered by data analytics and market insights." />
        </div>
      </section>

      <section id="projects" className="py-20 px-6 text-center bg-gray-50" data-aos="fade-up">
  <h2 className="text-3xl font-semibold mb-8">Our Projects</h2>

  <div className="max-w-4xl mx-auto text-left text-gray-800 space-y-6">

    <div>
      <h3 className="text-2xl font-bold text-blue-700">
        Leveraging AI/ML for Customized Credit Assessment of the Bodo Tribe
      </h3>
      <p>
        This project is funded under the Tribal Area Sub Plan (TSP) scheme by the Innovation and Business Incubation Technology Foundation (IBITF), IIT Bhilai. The aim is to develop a robust AI/ML-based credit assessment platform tailored for the Bodo Tribe in the Bodoland Territorial Region.
      </p>
      <p>
        The goal is to integrate alternative credit scoring models that consider socio-cultural and economic indicators specific to tribal communities. This system will help financial institutions improve credit access to underbanked tribal populations using data-driven intelligence.
      </p>
      <p className="text-sm text-gray-600">
        Sanctioned Amount: ₹16.5 Lakhs | Duration: 2 years | Status: Ongoing
      </p>
    </div>

    {/* <div>
      <h3 className="text-2xl font-bold text-blue-700">
        Secure FinTech Platform for Fraud Detection
      </h3>
      <p>
        Funded by <strong>IBITF, IIT Bhilai</strong>, this project focuses on building an intelligent software platform for identifying fraudulent transactions in digital finance. The system leverages AI/ML to flag anomalies and ensure secure and transparent operations in FinTech ecosystems.
      </p>
      <p>
        Core components include secure communication channels, real-time fraud scoring, and adaptive threat intelligence. This initiative strengthens trust in digital financial systems, especially for underserved and vulnerable users.
      </p>
      <p className="text-sm text-gray-600">
        Sanctioned Amount: ₹16.5 Lakhs | Status: Active
      </p>
    </div> */}

  </div>
</section>

      <section id="team" className="py-20 px-6 bg-white text-center" data-aos="fade-up">
        <h2 className="text-3xl font-semibold mb-10">Our Team</h2>
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          <div className="flex flex-col items-center">
            <img src="/team/ayanima-maity-founder.jpg" alt="Ayanima Maity" className="w-40 h-40 object-cover rounded-full shadow mb-4" />
            <h3 className="text-xl font-bold">Ms. Ayanima Maity</h3>
            <p className="text-sm text-blue-600 mb-2">Co-Founder & Designated Partner</p>
            <p className="text-sm text-gray-700 text-center px-4 mt-2">
              BTech (ECE), MBA (Finance) with 9+ years experience. Ex-TCS (India), Our Power (UK), Utilita Energy (UK), Computershare (UK), NESFB-Slice (India). Led IT and finance projects as business analyst and assistant manager.
            </p>
            <a href="https://linkedin.com/in/ayanimabiswas" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline mt-2">
              LinkedIn Profile
            </a>
          </div>
          <div className="flex flex-col items-center">
            <img src="/team/sudip-biswas-founder.jpg" alt="Dr. Sudip Biswas" className="w-40 h-40 object-cover rounded-full shadow mb-4" />
            <h3 className="text-xl font-bold">Dr. Sudip Biswas</h3>
            <p className="text-sm text-blue-600 mb-2">Co-Founder & Designated Partner</p>
            <p className="text-sm text-gray-700 text-center px-4 mt-2">
              PhD, University of Edinburgh | Associate Professor, IIIT Guwahati | IEEE Member | Expert in 6G, signal processing, optimization | PI/co-PI in 10+ govt. funded and international projects worth INR 2.5 Cr.
            </p>
            <a href="https://linkedin.com/in/sudip-biswas-sb1788" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline mt-2">
              LinkedIn Profile
            </a>
          </div>
        </div>
      </section>

      <section id="contact" className="py-20 px-6 bg-gray-100 text-center" data-aos="zoom-in">
        <h2 className="text-3xl font-semibold mb-4">Contact Us</h2>
        <p className="text-lg text-gray-700 mb-2">Email us at:</p>
        <p className="text-xl font-medium text-blue-700 mb-4">
          <a href="mailto:support@formicarylabs.in" className="hover:underline">support@formicarylabs.in</a>
        </p>
        <p className="text-gray-700 mb-6">Address: IIITG Incubation Center, IIIT Guwahati, Assam 781015, India</p>
      </section>

      <section id="contact-form" className="py-20 px-6 bg-white text-center" data-aos="fade-up">
        <h3 className="text-2xl font-semibold mb-6">Send Us a Message</h3>
        <form action="https://formsubmit.co/support@formicarylabs.in" method="POST" className="max-w-xl mx-auto space-y-6">
          <input type="hidden" name="_next" value="https://formicarylabs.in/thanks" />
          <input type="hidden" name="_captcha" value="true" />
          <input type="text" name="name" placeholder="Your Name" required className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600" />
          <input type="email" name="email" placeholder="Your Email" required className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600" />
          <textarea name="message" placeholder="Your Message" required rows="5" className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"></textarea>
          <button type="submit" className="w-full py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition">Send Message</button>
        </form>
      </section>
      <section className="px-6 py-4 bg-yellow-100 text-yellow-900 text-sm text-center">
  <strong>Disclaimer:</strong> This website is currently in its beta version and under active development. The content presented here may be incomplete or approximate. For accurate information, please contact us at <a href="mailto:support@formicarylabs.in" className="underline">support@formicarylabs.in</a>.
</section>

<footer className="py-10 text-center bg-gray-50 text-sm text-gray-600">
  Supported by IIIT Guwahati I&E Cell and IBITF, IIT Bhilai
  <p className="text-xs text-gray-500 mt-2">
    Formicary Innovation Labs LLP | LLPIN: ACM-2983 | Registered in Assam, India | UDYAM Registration Number: UDYAM-AS-03-0065202
  </p>
</footer>
    </div>
  );
}

function ServiceCard({ title, desc }) {
  return (
    <div className="bg-white p-6 rounded-2xl shadow hover:shadow-lg transition-all" data-aos="fade-up">
      <h3 className="text-xl font-bold mb-2">{title}</h3>
      <p className="text-gray-600">{desc}</p>
    </div>
  );
}
